import { apiV2 } from 'src/services/api'
import {
  ZipcodeAddress,
  AddressResultData,
} from '../../components/informeCep/types'
import { customerAddressesMapper } from '../../components/informeCep/mappers/customerAddressesMapper'

export const getCustomerAddresses = async (): Promise<AddressResultData> => {
  const { data } = await apiV2.get<ZipcodeAddress[]>(
    `${process.env.REACT_APP_API_URI_V2}/canais/consumidores/enderecos`
  )
  return { result: customerAddressesMapper(data) }
}
